module.exports = __webpack_public_path__ + "media/night/227-d9af1c81.svg";